export const SPRAY_EVENTS_FOR_SUBMISSION_LOAD_REQUESTED = 'SPRAY_EVENTS_FOR_SUBMISSION_LOAD_REQUESTED';
export const SPRAY_EVENTS_FOR_SUBMISSION_LOAD_SUCCEEDED = 'SPRAY_EVENTS_FOR_SUBMISSION_LOAD_SUCCEEDED';
export const SPRAY_EVENTS_FOR_SUBMISSION_LOAD_FAILED = 'SPRAY_EVENTS_FOR_SUBMISSION_LOAD_FAILED';
export const RESET_SPRAY_EVENTS_FOR_SUBMISSION = 'RESET_SPRAY_EVENTS_FOR_SUBMISSION';
